"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgedIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _typographyModule = _interopRequireDefault(require("../../styles/typography.module.css"));
var _BadgedIconModule = _interopRequireDefault(require("./BadgedIcon.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BadgedIcon = _ref => {
  let {
    name,
    showBadge = true,
    classNames,
    size = 'medium',
    type = 'solid',
    ariaLabel
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!name && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_BadgedIconModule.default.iconContainer, _BadgedIconModule.default[size], classNames?.wrapper)
  }, /*#__PURE__*/React.createElement(_Icon.Icon, {
    ariaLabel: ariaLabel,
    name: name,
    className: classNames?.icon
    // @ts-ignore - TS17001 - JSX elements cannot have multiple attributes with the same name.
    ,
    name: name,
    size: size === 'large' ? 'medium' : size,
    type: type,
    color: _typography.TEXT_COLORS.clickable
  }), showBadge && /*#__PURE__*/React.createElement(BadgeIcon, {
    className: classNames?.badgeIcon
  })));
};
exports.BadgedIcon = BadgedIcon;
const BadgeIcon = _ref2 => {
  let {
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("svg", {
    className: (0, _classify.default)(_BadgedIconModule.default.badgeIcon, _typographyModule.default[_typography.TEXT_COLORS['clickable']], className),
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46573 1.0335L8.10352 4.61465L11.6941 6.24816C11.883 6.3424 12.009 6.53088 12.009 6.71936C12.009 6.90784 11.883 7.09632 11.6941 7.15915L8.10352 8.82407L6.46573 12.4052C6.37124 12.5937 6.18226 12.7194 5.99329 12.7194C5.80431 12.7194 5.61533 12.5937 5.55234 12.4052L3.88305 8.82407L0.292498 7.19056C0.103521 7.09632 0.0090332 6.90784 0.0090332 6.71936C0.0090332 6.53088 0.103521 6.3424 0.292498 6.24816L3.88305 4.61465L5.55234 1.0335C5.61533 0.845015 5.80431 0.71936 5.99329 0.71936C6.18226 0.71936 6.37124 0.845015 6.46573 1.0335Z",
    fill: "currentColor"
  }));
};